import React from 'react'
import MappingRow from './MappingRow'
import { EmptyState, ErrorState, LoadingState } from '../../Shared/Components/MappingStates'
import Shared from '../../Shared/mappingUi.module.css'
import Style from '../salesPersonMapping.module.css'

const MappingList = ({
    rows,
    erpSalesPersons,
    ecommerceSalesPersons,
    isLoading,
    loadError,
    isDisabled,
    onChange,
    onRemove
}) => {
    if (isLoading) {
        return <LoadingState message="Loading sales person details..." />
    }
    if (loadError) {
        return <ErrorState message={loadError} />
    }
    if (rows.length === 0) {
        return (
            <EmptyState
                icon="uil-users-alt"
                message="No sales person mappings yet"
                hint="Pick an ERP and an eCommerce sales person above, then add the pair."
            />
        )
    }

    return (
        <>
            <div className={`${Shared.grid} ${Style.grid} ${Shared.listHeader}`}>
                <span>ERP Sales Person</span>
                <span />
                <span>eCommerce Sales Person</span>
                <span className={Shared.listHeaderAction}>Action</span>
            </div>
            <ul className={Shared.list}>
                {rows.map((row) => (
                    <MappingRow
                        key={row.rowId}
                        row={row}
                        erpSalesPersons={erpSalesPersons}
                        ecommerceSalesPersons={ecommerceSalesPersons}
                        isDisabled={isDisabled}
                        onChange={onChange}
                        onRemove={onRemove}
                    />
                ))}
            </ul>
        </>
    )
}

export default MappingList
